import createApp from './app.js'

import authService from './service.auth.js'
import firestoreService from './service.firestore.js'
import messagingService from './service.messaging.js'

const appConfig = {"apiKey":"AIzaSyClrkRr7IG6HSgct0ErASI6DOUwJq2JzZw","authDomain":"careecon-for-work-sekou.firebaseapp.com","databaseURL":"https:\u002F\u002Fcareecon-for-work-sekou.firebaseio.com","projectId":"careecon-for-work-sekou","storageBucket":"careecon-for-work-sekou.appspot.com","messagingSenderId":"61541111459","appId":"1:61541111459:web:82c2f87233c26704e85116","measurementId":"G-60891FV8WR"}

export default async (ctx, inject) => {
  /****************************************
  **************** LAZY MODE **************
  ****************************************/

  const { firebase, session } = await createApp(appConfig, ctx)

  let servicePromises = []

  if (process.server) {
    servicePromises = [
      authService(session, firebase, ctx, inject),
    firestoreService(session, firebase, ctx, inject),

    ]
  }

  if (process.client) {
    servicePromises = [
      authService(session, firebase, ctx, inject),
      firestoreService(session, firebase, ctx, inject),
      messagingService(session, firebase, ctx, inject),

    ]
  }

  const [
    auth,
    firestore,
    messaging
  ] = await Promise.all(servicePromises)

  const fire = {
    auth: auth,
    firestore: firestore,
    messaging: messaging
  }

    inject('fireModule', firebase)
    ctx.$fireModule = firebase

  inject('fire', fire)
  ctx.$fire = fire
}
